<div class="card-header">
  <app-breadcrumb currentPage="Overzicht van bewinden"></app-breadcrumb>
</div>
<div class="card-body">
  <mat-paginator [length]="totalElements"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="pageEvent = updatePage($event)">
  </mat-paginator>

  <table matSort (matSortChange)="sortPage($event)" class="table table-hover">
    <tr>
      <th mat-sort-header="firstUser.name.firstName">Bewindvoerder</th>
      <th mat-sort-header="firstUser.username">E-mailadres</th>
      <th mat-sort-header="caseNumber">BM/CB</th>
      <th mat-sort-header="name.firstName">Rechthebbende</th>
      <th mat-sort-header="createdAt">Aangemaakt</th>
      <th mat-sort-header="startDate">Instellingsdatum</th>
      <th>actions</th>
    </tr>
    <tr *ngFor="let row of content" [routerLink]="'/bewind/'+row.id" class="pointer">
      <td>{{row.nameOfUser}}</td>
      <td>{{row.emailOfUser}}</td>
      <td>{{row.caseNumber}}</td>
      <td>{{row.nameOfClient}}</td>
      <td>{{row.createdAt}}</td>
      <td>{{row.startDate}}</td>
      <td>
        <mat-icon matTooltip="Gift jaar toegang" (click)="gift(row, $event)">attach_money</mat-icon>
      </td>
    </tr>
  </table>
</div>
